<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                                v-if="$checkRole($accessModule.supplier_contract_sor, 'update')"
                                label="Save"
                                @click="updateItem"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form v-bind:class="{'run-loading':Loadings.popup}">
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="3">
                                        <gofix-text-field label="SOR Code" oneline>
                                            {{sorItem.sor_code}}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-text-field label="SOR Group" oneline>
                                            {{ sorItem.sor_group ? sorItem.sor_group.description_one : '--' }}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field label="Start Date" oneline>
                                            {{ sorItem.effective_date | formatDatebyMoment("YYYY-MM-DD", "DD.MM.YYYY") }}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="12">
                                        <gofix-text-field class="mb-3" label="Service Category" oneline>
                                            {{ sorItem.service_category ? sorItem.service_category.name : "--" }}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="12">
                                        <gofix-text-field class="mb-3" label="Description 01" oneline>
                                            {{ sorItem.description_one ? sorItem.description_one : '--' }}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="12">
                                        <gofix-text-field class="mb-3" label="Description 02" oneline>
                                            {{ sorItem.description_two ? sorItem.description_two : '--' }}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field class="mb-3" label="Work Type" oneline>
                                            {{ sorItem.work_type ? sorItem.work_type : '--' }}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-text-field class="mb-3" label="Fault Type" oneline>
                                            {{ sorItem.fault_type ? sorItem.fault_type : '--' }}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input-number
                                                label="Unit Price"
                                                v-model="vendor_linking_sor.unit_price_tmp"
                                                prefix="$"></gofix-form-input-number>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field class="mt-3" label="Unit of Measurement" oneline>
                                            {{sorItem.unit_of_measurement}}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="3">
                                        <gofix-text-field class="mt-3" label="Minimum Quatity" oneline>
                                            {{sorItem.min_qty}}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-text-field class="mt-3" label="Maximum Quatity" oneline>
                                            {{sorItem.max_qty}}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-text-field class="mt-3" label="Warranty [Months]" oneline>
                                            {{sorItem.warranty}}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-text-field class="mt-3" label="Tag" oneline>
                                            {{sorItem.tag}}
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 's-sor-detail',
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                contractTerms: null,
                disabled: false,
                vendor_linking_sor: {
                    unit_price: null,
		            unit_price_tmp: null
                }
            }
        },
        created () {
            //Check in C-contract
            if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-supplier`);
            }

            if(!this.$route.params.hasOwnProperty('sor_id') || isNaN(this.$route.params.sor_id)) {
                return this.$router.push(`/v2/contract-supplier/${this.$route.params.id}/sor`);
            }

            if(this.ClientContractID && !this.contractTerms && this.ClientContractID.contract_terms){
                this.contractTerms = this.ClientContractID.contract_terms[0];
            }
            this.disabled = true;
            this.vendor_linking_sor.unit_price = this.sorItem.unit_price ? this.sorItem.unit_price : '';
            if(this.sorItem.vendor_linking_sor && this.sorItem.vendor_linking_sor.length > 0) {
                this.disabled = false;
                this.vendor_linking_sor = Object.assign({}, this.sorItem.vendor_linking_sor[0]);
                this.vendor_linking_sor.unit_price = JSON.stringify(Number(this.vendor_linking_sor.unit_price));
            }
            this.vendor_linking_sor.unit_price_tmp = this.$accounting.formatMoney(this.vendor_linking_sor.unit_price);

            if(this.$route.params.sor_id != 0 && this.sorItem.id != this.$route.params.sor_id){
                this.$store.dispatch("v2SorController/getItem",this.$route.params.sor_id)
                    .then(respone => {
                        let vendor_linking_sor_supplier = respone.data.data.vendor_linking_sor.filter(item => item.supplier_contract_id == this.$route.params.id);
                        if(vendor_linking_sor_supplier.length) {
                            this.vendor_linking_sor = Object.assign({}, vendor_linking_sor_supplier[0]);
                            this.vendor_linking_sor.unit_price = JSON.stringify(Number(this.vendor_linking_sor.unit_price));
                            this.vendor_linking_sor.unit_price_tmp = this.$accounting.formatMoney(this.vendor_linking_sor.unit_price);
                        } else {
                            this.vendor_linking_sor.unit_price_tmp = this.$accounting.formatMoney(respone.data.data.unit_price);
                        }
                    });
            }
        },
        watch: {
            contractTerms: function (val) {
                this.loadService()
            },
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
        },
        computed: {
            ...mapGetters({
                Loadings:  'v2SorController/Loadings',
                Groups:  'v2SorController/Groups',
                sorItem:  'v2SorController/sorItem',
                Services:  'v2SorController/Services',
                Validate:  'v2SorController/Validate',
                ClientContractID: 'ContractController/ClientContractID',
                Items:  'v2SorController/Items'
            })
        },
        methods:{
            loadService(){
                this.$store.dispatch("v2SorController/getServices",this.ClientContractID.service_category_root_id);
            },
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if(parentNode.isBatch){
                    this.$store.dispatch("v2SorController/getService",{
                        contract_id:this.$route.params.id,
                        service_id:parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback()
                    })
                }else{
                    parentNode.children = undefined;
                    callback()
                }
            },
            updateItem(){

                this.vendor_linking_sor.unit_price = this.$accounting.unformat(this.vendor_linking_sor.unit_price_tmp);
                if(!this.vendor_linking_sor.id) {
                    return;
                }
                if(!this.vendor_linking_sor.unit_price) {
                    return this.$alertNotification("Unit price is required.", "danger");
                }
                this.$store.dispatch("v2SorController/saveVendorLinkingSOR", this.vendor_linking_sor).then( data => {
                    this.$alertNotification(this.$notificationV2('editing', 'vendor_linking_sor'));
                }).catch(err => {
                    if(err.response.data.error.message.error) {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                    else {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                });
                /*let contract_term_id = this.sorItem.contract_term_id;
                if(!contract_term_id){
                    contract_term_id = this.ClientContractID.contract_terms[0].id;
                }
                if(!this.sorItem.sor_group_id){
                    this.sorItem.sor_group_id = this.ClientContractID.sor_group_root_id
                }

                this.$store.dispatch("v2SorController/checkValidate")
                .then(validate => {
                    this.$store.dispatch("v2SorController/saveSorItem",contract_term_id).then( data => {
                        this.$bvToast.toast("Create computed!", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                        if(this.$route.params.sor_id == 0){
                            this.$router.push({ name:"edit-sor",params: { sor_id:data.id }})
                        }
                    }).catch(err => {
                        this.$bvToast.toast(err, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        });
                    });
                })
                .catch(err => {
                    this.$bvToast.toast("Please enter in required fields", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    });
                })*/
            },
        }
    }
</script>
